// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btn-light {\n  background-color: #fff;\n  border-color: #ced4da;\n}", "",{"version":3,"sources":["webpack://./src/client/css/bootstrap-select-button.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,qBAAqB;AACvB","sourcesContent":[".btn-light {\n  background-color: #fff;\n  border-color: #ced4da;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
